"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLogoColors = void 0;
var styled_components_1 = require("styled-components");
var useLogoColors = function (mode) {
    var _a = (0, styled_components_1.useTheme)().logo, brandColor = _a.brandColor, lightColor = _a.lightColor, darkColor = _a.darkColor;
    var strokeColor = mode === 'dark' ? lightColor : darkColor;
    return {
        brandColor: brandColor,
        strokeColor: strokeColor,
    };
};
exports.useLogoColors = useLogoColors;
